import Card from '../card/index';
import WindGauge from '../wind-gauge/index';
import Loader from '../loader/index';
import DataLine from './data-line';
import { convertWindBearing16, convertWindBearing8 } from '../../utils/convert-wind-bearing';
import style from './style.scss';

/**
 * The WindSummary component is displayed on the home page as part of the primary live
 * data view. It displays live wind direction and speed information.
 *
 * props:
 * - data: A data model object containing the data needed for the view
 * - speedUnit: The current wind speed unit
 * - windSpeedFormatter: A function for formatting mean wind speed values for display purposes
 * - windGustFormatter: A function for formatting wind gust values for display purposes
 * - timeFormatter: A function for formatting timestamps for display purposes
 */

const WindSummary = props => {

	const { data, windSpeedFormatter, windGustFormatter, timeFormatter, speedUnit } = props;

	if (!data) {
		return (
			<Card>
				<Loader />
			</Card>
		);
	}

	const liveSpeed = windGustFormatter(data.liveWindSpeed);

	const direction = data.currentWindGust === 0
		? 'Calm'
		: convertWindBearing16(data.meanWindBearing) + ` (${data.meanWindBearing}°)`;

	return (
		<Card>
			<div class={style.wind_layout}>
				<div class={style.wind_gauge_wrapper}>
					<WindGauge size={130} windSpeed={liveSpeed} windBearing={data.liveWindBearing} />
				</div>

				<div class={style.wind_direction_speed}>
					<DataLine label="Direction" value={direction} />
					<DataLine label="Avg speed" value={windSpeedFormatter(data.meanWindSpeed, speedUnit)} unit={` ${speedUnit}`} />
					<DataLine label="Gusting to" value={windGustFormatter(data.currentWindGust, speedUnit)} unit={` ${speedUnit}`} />
				</div>

				<div class={style.wind_gust_high}>
					<div>Max Gust</div>
					<div class={style.extreme_value}>
						{
							data.highWindGust > 0
								? <span class={style.shrink_unit}>{convertWindBearing8(data.highWindGustBearing)} </span>
								: null
						}
						<span>{ windGustFormatter(data.highWindGust) }</span>
						<span class={style.shrink_unit}> { speedUnit }</span>
					</div>
					<div>{ timeFormatter(data.highWindGustTime) }</div>
				</div>
			</div>
		</Card>
	);

};

export default WindSummary;



// WEBPACK FOOTER //
// ./components/live/wind-summary.js